import { useTranslation } from "react-i18next";

function Checkoutv1Cancel() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-gray-50 px-6">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-orange-100">
        <svg
          className="h-10 w-10 text-orange-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>

      <h1 className="text-center font-[Poppins] text-3xl font-semibold text-gray-900">
        {t("checkoutv1.cancel.title")}
      </h1>

      <p className="max-w-md text-center font-[Poppins] text-lg font-medium text-gray-600">
        {t("checkoutv1.cancel.text")}
      </p>

      <button
        onClick={() => history.back()}
        className="rounded-2xl bg-[#FF8D27] px-12 py-4 font-[Poppins] text-lg font-medium text-white transition-colors hover:bg-[#e67d1f]"
      >
        {t("checkoutv1.cancel.button")}
      </button>
    </div>
  );
}

export { Checkoutv1Cancel };
